// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistemaFranquia_ListWithFranquiaDataResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ConfiguracoesSistemaFranquia_ConfiguracaoRow } from './ConfiguracoesSistemaFranquia_ConfiguracaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ConfiguracoesSistemaFranquia_ListWithFranquiaDataResponseDados = ConfiguracoesSistemaFranquia_ConfiguracaoRow[];

export type ConfiguracoesSistemaFranquia_ListWithFranquiaDataResponse = ApiResponse<ConfiguracoesSistemaFranquia_ListWithFranquiaDataResponseDados>;

registerResponseContract('ConfiguracoesSistemaFranquia_ListWithFranquiaDataResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      config_sistema_franquia_id: { type: 'number',  required: false },
      nome:                       { type: 'string',  required: true },
      titulo:                     { type: 'string',  required: false },
      descricao:                  { type: 'string',  required: false },
      valor_padrao:               { type: 'string',  required: false },
      valor:                      { type: 'string',  required: false },
    },
  },
})
